/**
 * FogOfWarOverlay
 *
 * Displayed when the anti-scraping threshold is exceeded.
 * Semi-transparent overlay with a countdown timer.
 */
import { useMapStore } from '@/stores/mapStore';

export default function FogOfWarOverlay() {
  const countdown = useMapStore((s) => s.fogOfWarCountdown);

  return (
    <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center bg-impact-dark/70 backdrop-blur-sm animate-fade-in">
      <div className="pointer-events-auto max-w-sm rounded-2xl border border-amber-700/60 bg-impact-overlay/90 p-6 text-center shadow-2xl backdrop-blur">
        <div className="mb-3 flex justify-center">
          <svg className="h-10 w-10 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
        <h3 className="mb-1 font-display text-lg font-semibold text-amber-300">
          Rate Limit Reached
        </h3>
        <p className="mb-4 text-sm text-slate-400">
          Slow down to protect sensitive location data. The map will resume in…
        </p>
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-amber-500/20 text-2xl font-bold text-amber-300">
          {countdown}
        </div>
      </div>
    </div>
  );
}
